module.exports = __webpack_public_path__ + "img/EstudiosSinfondo.45f4cbe2.svg";